import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRippleModule, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { ButtonAddComponent } from "@component/button-add/button-add.component";
import { ButtonCancelDialogComponent } from "@component/button-cancel-dialog/button-cancel-dialog.component";
import { ButtonCloseDialogComponent } from "@component/button-close-dialog/button-close-dialog.component";
import { ButtonCloseComponent } from "@component/button-close/button-close.component";
import { ButtonDeleteAndCancelComponent } from "@component/button-delete-and-cancel/button-delete-and-cancel.component";
import { ButtonDeleteComponent } from "@component/button-delete/button-delete.component";
import { ButtonSaveComponent } from "@component/button-save/button-save.component";
import { BaseDto } from "@models/base/baseDto.model";
import { AccionesDialog, Roles } from "@models/base/identificadores.model";
import { CalendarioJudicialDto } from "@models/calendarioJudicial/calendarioJudicialDto.model";
import { CreateCalendarioJudicialRequest } from "@models/calendarioJudicial/createCalendarioJudicialDto.model";
import { UpdateCalendarioJudicialRequest } from "@models/calendarioJudicial/updateCalendarioJudicialDto.model";
import { JuzgadoDto } from "@models/juzgado/juzgadoDto.model";
import { JuzgadoFilter } from "@models/juzgado/juzgadoFilter.model";
import { CreateUsuarioRequest } from "@models/usuario/createUsuarioRequest.model";
import { UpdateUsuarioRequest } from "@models/usuario/updateUsuarioRequest.model";
import { UsuarioDto } from "@models/usuario/usuarioDto.model";
import { CalendarioJudicialService } from "@services/calendarioJudicial/calendarioJudicial.service";
import { FueroService } from "@services/fuero/fuero.service";
import { JuridiccionService } from "@services/juridiccion/juridiccion.service";
import { JuzgadoService } from "@services/juzgado/juzgado.service";
import { SnackBarService } from "@services/snackBar/snack-bar-service.service";
import { AutocompleteGenericoComponent } from "@views/busquedas/autocomplete-generico/autocomplete-generico.component";
import { BuscarLocalidadGeorefComponent } from "@views/busquedas/buscar-localidad-georef/buscar-localidad-georef.component";
import { BuscarLocalidadComponent } from "@views/busquedas/buscar-localidad/buscar-localidad.component";
import { BuscarProvinciaGeorefComponent } from "@views/busquedas/buscar-provincia-georef/buscar-provincia-georef.component";
import { BuscarProvinciaLocalidadGeorefComponent } from "@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-dialog-form-calendario-judicial',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, BuscarLocalidadComponent, ButtonAddComponent, AutocompleteGenericoComponent, BuscarProvinciaGeorefComponent, BuscarLocalidadGeorefComponent, BuscarProvinciaLocalidadGeorefComponent],
  templateUrl: './dialog-form-calendario-judicial.component.html',
  styleUrl: './dialog-form-calendario-judicial.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormCalendarioJudicialComponent {
  accionesDialog = AccionesDialog;
  calendarioJudicialDto!: CalendarioJudicialDto;
  empresaUsuario: any;
  get f() { return this.form.controls; }
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  juzgados: JuzgadoDto[] = [];
  fueros: BaseDto[] = [];
  jurisdicciones: BaseDto[] = [];
  showSpinnerJurisdicciones = false;
  showSpinnerFueros = false;
  showSpinnerJuzgados = false;
  constructor(
    public dialogRef: MatDialogRef<DialogFormCalendarioJudicialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private calendarioJudicialService: CalendarioJudicialService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private juzgadoService: JuzgadoService,
    private juridiccionService: JuridiccionService,
    private fueroService: FueroService,
  ) {

  }

  ngOnInit(): void {
    this.calendarioJudicialDto = this.data || {};
    this.data.descripcion = this.data?.item?.motivo || {};
    this.getAllFueros()
    this.getAllJurisdicciones()
    this.setForm();
  }
  setForm() {
    const esEdicion = this.data.accion === AccionesDialog.Modificar;

    this.form = this.formBuilder.group({
      Id: [{ value: this.calendarioJudicialDto?.id || null, disabled: esEdicion }],
      Fecha: [{ value: new Date(this.calendarioJudicialDto?.fecha as Date) || null, disabled: false }, Validators.compose([Validators.required])],
      EsHabil: [{ value: this.calendarioJudicialDto?.esHabil || false, disabled: false }],
      EsFeriado: [{ value: this.calendarioJudicialDto?.esFeriado || false, disabled: false }],
      EsFeriaJudicial: [{ value: this.calendarioJudicialDto?.esFeriaJudicial || false, disabled: false }],
      Motivo: [{ value: this.calendarioJudicialDto?.motivo || null, disabled: false }, Validators.compose([Validators.required])],
      IdJurisdiccion: [{ value: this.calendarioJudicialDto?.jurisdiccion?.id || null, disabled: this.jurisdicciones.length === 0 }],
      IdFuero: [{ value: this.calendarioJudicialDto?.fuero?.id || null, disabled: this.fueros.length === 0 }],
      IdJuzgado: [{ value: this.calendarioJudicialDto?.juzgado?.id || null, disabled: this.juzgados.length === 0 }],
      HorarioDesde: [{ value: this.calendarioJudicialDto?.horarioDesde || null, disabled: false }],
      HorarioHasta: [{ value: this.calendarioJudicialDto?.horarioHasta || null, disabled: false }]
    });

    ['EsFeriado', 'EsFeriaJudicial'].forEach(controlName => {
      this.form.get(controlName)?.valueChanges.subscribe(val => {
        if (val === true) {
          this.form.get('EsHabil')?.setValue(false, { emitEvent: false });
        }
      });
    });

    this.form.get('EsHabil')?.valueChanges.subscribe(val => {
      if (val === true) {
        ['EsFeriado', 'EsFeriaJudicial'].forEach(c => {
          this.form.get(c)?.setValue(false, { emitEvent: false });
        });
      }
    });
  }


  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spCalendarioJudicial")
    this.calendarioJudicialService.create(this.setCreateCalendarioJudicialRequest())
      .subscribe(
        data => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let idRol = this.form.controls['IdRol'].value;

    this.spinner.show("spCalendarioJudicial")
    this.calendarioJudicialService.update(this.setUpdateCalendarioJudicialRequest())
      .subscribe(
        data => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spCalendarioJudicial")
    this.calendarioJudicialService.delete(this.calendarioJudicialDto.id)
      .subscribe(
        data => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.usuario });
        },
        error => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateCalendarioJudicialRequest(): CreateCalendarioJudicialRequest {
    const {
      Fecha,
      EsHabil,
      EsFeriado,
      EsFeriaJudicial,
      Motivo,
      IdJurisdiccion,
      IdFuero,
      IdJuzgado,
      HorarioDesde,
      HorarioHasta
    } = this.form.controls;

    const getValueOrNull = (control: AbstractControl): any => control.value === '' ? null : control.value;


    const request = new CreateCalendarioJudicialRequest();
    request.fecha = getValueOrNull(Fecha);
    request.esHabil = EsHabil.value;
    request.esFeriado = EsFeriado.value;
    request.esFeriaJudicial = EsFeriaJudicial.value;
    request.motivo = Motivo.value;
    request.idJurisdiccion = getValueOrNull(IdJurisdiccion);
    request.idFuero = getValueOrNull(IdFuero);
    request.idJuzgado = getValueOrNull(IdJuzgado);
    request.horarioDesde = getValueOrNull(HorarioDesde);
    request.horarioHasta = getValueOrNull(HorarioHasta);

    return request;
  }

  setUpdateCalendarioJudicialRequest(): UpdateCalendarioJudicialRequest {
    const {
      Fecha,
      EsHabil,
      EsFeriado,
      EsFeriaJudicial,
      Motivo,
      IdJurisdiccion,
      IdFuero,
      IdJuzgado,
      HorarioDesde,
      HorarioHasta
    } = this.form.controls;

    const getValueOrNull = (control: AbstractControl): any => control.value === '' ? null : control.value;


    const request = new UpdateCalendarioJudicialRequest();
    request.fecha = getValueOrNull(Fecha);
    request.esHabil = EsHabil.value;
    request.esFeriado = EsFeriado.value;
    request.esFeriaJudicial = EsFeriaJudicial.value;
    request.motivo = Motivo.value;
    request.idJurisdiccion = getValueOrNull(IdJurisdiccion);
    request.idFuero = getValueOrNull(IdFuero);
    request.idJuzgado = getValueOrNull(IdJuzgado);
    request.horarioDesde = getValueOrNull(HorarioDesde);
    request.horarioHasta = getValueOrNull(HorarioHasta);

    return request;
  }


  setUpdateUsuarioRequest(): UpdateUsuarioRequest {

    const updateUsuarioRequest = new UpdateUsuarioRequest();

    updateUsuarioRequest.nombre = this.form.controls['Nombre'].value;
    updateUsuarioRequest.apellido = this.form.controls['Apellido'].value;
    updateUsuarioRequest.telefono = this.form.controls['Telefono'].value == "" ? null : this.form.controls['Telefono'].value;
    updateUsuarioRequest.direccion = this.form.controls['Direccion'].value == "" ? null : this.form.controls['Direccion'].value;

    return updateUsuarioRequest
  }



  onReset() {
    this.form.reset();
  }

  trackByusuarios(index: number, usuario: any): any { return usuario; }



  async getUsuarioById(id: number) {
    this.spinner.show("spCalendarioJudicial")
    await this.calendarioJudicialService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spCalendarioJudicial")
          this.calendarioJudicialDto = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spCalendarioJudicial")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }

  onSeleccionarJuzgado(elemento: any) {
    console.log('Juzgado:', elemento);
  }

  onSeleccionarFuero(elemento: any) {
    this.getAllJuzgados(elemento.id);
    console.log('Fuero:', elemento);
  }

  onSeleccionarJurisdiccion(elemento: any) {
    console.log('Jurisdiccion:', elemento);
  }

  getAllJuzgados(idFuero: number) {
    this.showSpinnerJuzgados = true
    let juzgadoFilter = new JuzgadoFilter()
    juzgadoFilter.idsFuero?.push(idFuero)

    this.juzgadoService.getAllByFilter(juzgadoFilter)
      .subscribe(
        data => {
          this.showSpinnerJuzgados = false
          this.juzgados = data
        },
        error => {
          this.showSpinnerJuzgados = false
          this.snackBar.showError(error, "Error");
        })
  }

  getAllJurisdicciones() {
    this.showSpinnerJurisdicciones = true
    this.juridiccionService.getAll()
      .subscribe(
        data => {
          this.showSpinnerJurisdicciones = false
          this.jurisdicciones = data
        },
        error => {
          this.showSpinnerJurisdicciones = false
          this.snackBar.showError(error, "Error");
        })
  }

  getAllFueros() {
    this.showSpinnerFueros = true
    this.fueroService.getAll()
      .subscribe(
        data => {
          this.showSpinnerFueros = false
          this.fueros = data
        },
        error => {
          this.showSpinnerFueros = false
          this.snackBar.showError(error, "Error");
        })
  }
}


